export const hasLongWord = (title: string): boolean => {
    return !!(
        title &&
        (title.split(' ').length === 1
            ? title.length > 8
            : title.split(' ').some((word) => word.length > 12))
    );
};
